<template>
  <div
    class="row justify-content-center"
    :class="{ 'soha-page-loading-container': marginTop }"
  >
    <center class="soha-page-loading-card">
      <loading :size="size" />
    </center>
  </div>
</template>

<script>
import "@/assets/css/components/base/page-loading.css";
export default {
  name: "PageLoading",

  props: {
    size: {
      default: "22",
      type: String,
    },

    marginTop: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped></style>
